export default "__VITE_ASSET__D3P_8dT$__"